/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module HealthMonitorModule
 */

import {
    CUSTOM_ELEMENTS_SCHEMA,
    NgModule,
    NO_ERRORS_SCHEMA,
} from '@angular/core';

import { CommonModule } from '@angular/common';
import { SharedModule } from 'ng/shared/shared.module';
import { AviFormsModule } from 'ng/modules/avi-forms/avi-forms.module';
import { DataGridModule } from 'ng/modules/data-grid/data-grid.module';

import {
    DnsHealthMonitorConfigComponent,
    ExternalHealthMonitorConfigComponent,
    FtpHealthMonitorConfigComponent,
    HealthMonitorAuthenticationComponent,
    HealthMonitorListPageComponent,
    HealthMonitorModalComponent,
    HealthMonitorPortIpGroupComponent,
    HttpHealthMonitorConfigComponent,
    ImapsHealthMonitorConfigComponent,
    LdapHealthMonitorConfigComponent,
    NewlineConvertedTextareaComponent,
    PingHealthMonitorConfigComponent,
    Pop3HealthMonitorConfigComponent,
    RadiusHealthMonitorConfigComponent,
    SctpHealthMonitorConfigComponent,
    ServerMaintenanceModeComponent,
    SipHealthMonitorConfigComponent,
    SmtpHealthMonitorConfigComponent,
    TcpHealthMonitorConfigComponent,
    UdpHealthMonitorConfigComponent,
} from './components';

import { RbacModule } from '../rbac/rbac.module';
import { healthMonitorCollectionProvider } from './ajs-upgraded-providers';

const healthMonitorComponents = [
    DnsHealthMonitorConfigComponent,
    ExternalHealthMonitorConfigComponent,
    HealthMonitorModalComponent,
    HealthMonitorListPageComponent,
    HealthMonitorPortIpGroupComponent,
    RadiusHealthMonitorConfigComponent,
    SipHealthMonitorConfigComponent,
    HealthMonitorAuthenticationComponent,
    ImapsHealthMonitorConfigComponent,
    NewlineConvertedTextareaComponent,
    PingHealthMonitorConfigComponent,
    Pop3HealthMonitorConfigComponent,
    HttpHealthMonitorConfigComponent,
    ServerMaintenanceModeComponent,
    TcpHealthMonitorConfigComponent,
    UdpHealthMonitorConfigComponent,
    SctpHealthMonitorConfigComponent,
    SmtpHealthMonitorConfigComponent,
    LdapHealthMonitorConfigComponent,
    FtpHealthMonitorConfigComponent,
];

/**
 * @description
 *      Angular Module for Health Monitor related Components.
 *
 * @author Rajawant Prajapati
 */
@NgModule({
    declarations: [
        ...healthMonitorComponents,
    ],
    imports: [
        CommonModule,
        SharedModule,
        AviFormsModule,
        DataGridModule,
        RbacModule,
    ],
    providers: [
        healthMonitorCollectionProvider,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class HealthMonitorModule { }
